import React from 'react'
import MultiSelectSearchDropdown from '../../../components/MultiSelectSearchDropdown'
import FormattedDate from '../../../components/FormattedDate'
import styles from '../EkgRecordingReviewScreen.css'
import CancelIcon from 'static/images/cancel.svg'
import { getEKGInterpretationDisplayTextList, getEKGAlgorithmDeterminationDisplayText } from '../../../constants/recordingMaps'
import { FormattedMessage, injectIntl } from 'react-intl'

const interpretationCategories = [
  'PRIMARY_RHYTHM',
  'OTHER_RHYTHM',
  'PREMATURE_COMPLEX',
  'AV_CONDUCTION',
  'PACEMAKER',
  'MORPHOLOGY',
]

const categoryMap = {
  PRIMARY_RHYTHM: 'Common Rhythms',
  OTHER_RHYTHM: 'Cardiac Rhythms',
  PREMATURE_COMPLEX: 'Premature Complexes',
  AV_CONDUCTION: 'AV Conductions',
  PACEMAKER: 'Pacemaker',
  MORPHOLOGY: 'Morphologies',
}

class AddInterpretationPane extends React.Component {
  handleOnRemovalClick = interpretation => {
    const {
      selectedInterpretations,
      handleUpdateInterpretations,
    } = this.props

    const copySelectedInterpretations = [ ...selectedInterpretations ]

    if (copySelectedInterpretations) {
      const foundIndex = copySelectedInterpretations.indexOf(interpretation)
      if (foundIndex > -1) {
        copySelectedInterpretations.splice(foundIndex, 1)
      }

      handleUpdateInterpretations(copySelectedInterpretations)
    }
  }

  handleOnNotesBlur = e => {
    const {
      handleUpdateInterpretationNotes,
    } = this.props

    handleUpdateInterpretationNotes(e.target.value)
  }

  render() {
    const {
      interpretations: ints,
      selectedInterpretations,
      interpretationMap,
      handleUpdateInterpretations,
      memberInterpretationsDate,
      memberInterpretations,
      recording: {
        algorithmDetermination,
        algorithmPackage,
        bpm,
      },
      me,
      intl
    } = this.props

    const commentPlaceholder = intl.formatMessage({ id: 'placeholder.Comments' })


    let groupedInterpretations = interpretationCategories.map(key => ({
      key,
      label: categoryMap[key],
      options: [],
    }))

    const interpretationsLookup = {}

    if (ints.data) {
      ints.data.sortedByApi
        .forEach(id => {
          const int = ints.data.byId[id]

          const {
            category,
          } = int
          if (!interpretationsLookup[category]) {
            interpretationsLookup[category] = []
          }
          interpretationsLookup[category].push(int)
        })

      groupedInterpretations = groupedInterpretations.map(groupedInt => {
        const groupedInterpretation = groupedInt
        groupedInterpretation.options = interpretationsLookup[groupedInterpretation.key]
        return groupedInterpretation
      })
    }

    // Show Determination text, based on ekgAlgorithmDetermination,algorithmPackage & bpm
    const interpretationTitle = memberInterpretations ?
      getEKGInterpretationDisplayTextList(interpretationMap, memberInterpretations.interpretations) :
      getEKGAlgorithmDeterminationDisplayText(algorithmDetermination, algorithmPackage, bpm)

    return (
      <React.Fragment>
        <div className={styles.addInterpretationsPane}>
          <div className={styles.lastInterpretation}>
            <span className={styles.intType}>{interpretationTitle === 'NOINTERPRETATION' ? 'No Interpretation' : interpretationTitle}</span>
            &mdash;
            <span className={styles.intDate}><FormattedDate date={memberInterpretationsDate} me={me} /></span>
          </div>
          <h2><FormattedMessage id="heading.Add_Interpretation" /></h2>
          <div className={styles.selector}>
            <MultiSelectSearchDropdown
              value={selectedInterpretations}
              options={groupedInterpretations}
              getOptionValue={d => d.key}
              getOptionLabel={d => d.localizedDisplayText}
              handleOnSelectionClick={handleUpdateInterpretations}
              // height handled in css
            />
          </div>
          <h2>
            <FormattedMessage id="heading.Added_Interpretations" />
            <span className={styles.addedInterpretationCount}>
              {selectedInterpretations.length}
            </span>
          </h2>
          {selectedInterpretations && selectedInterpretations.length > 0 &&
            <ul className={styles.selectedInterpretations}>
              {selectedInterpretations &&
                selectedInterpretations.map(interpretation => (
                  <li
                    key={interpretation.key}
                  >
                    <button
                      className={styles.removeInterpretation}
                      onClick={() => this.handleOnRemovalClick(interpretation)}
                    >
                      <CancelIcon />
                    </button>
                    {interpretation.localizedDisplayText}
                  </li>
                ))
              }
            </ul>
          }
          <div>
            <textarea
              className={styles.textArea}
              placeholder={commentPlaceholder}
              onBlur={this.handleOnNotesBlur}
            />
          </div>
        </div>
      </React.Fragment>
    )
  }
}
export default injectIntl(AddInterpretationPane)



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/components/AddInterpretationPane.jsx